import { SagaIterator } from "redux-saga";
import { call, put, takeLatest } from "redux-saga/effects";

import { callGet } from "../../http_client";

import { marketsFetchError, marketsFetchRequest, marketsFetchSuccess } from "./actions";
import { MarketsActionTypes } from "./types";

export function* handleMarketsFetch(action: ReturnType<typeof marketsFetchRequest>): SagaIterator {
  try {
    const res = yield call(callGet, "/markets/", action.payload);
    yield put(marketsFetchSuccess({ items: res.data }));
  } catch (err) {
    yield put(marketsFetchError(err.message));
  }
}

function* watchMarketsSagas(): SagaIterator {
  yield takeLatest(MarketsActionTypes.FETCH_REQUEST, handleMarketsFetch);
}

export default watchMarketsSagas;
